'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var getIsValidStructId = exports.getIsValidStructId = function getIsValidStructId(structId) {
  return typeof structId === 'number' && Number.isFinite(structId) && !(structId % 1) || typeof structId === 'string' && Boolean(structId.length);
};